import React, { Fragment, useState, useEffect, useRef } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getGifsSearch } from "../../../actions/gif";

import MentorChatMessageItem from "./MentorChatMessageItem";
import GifItem from "../IME/GifItem";

const StreamChatRed = ({
  profile,
  auth: { user, isAuthenticated },
  messages,
  message,
  setMessage,
  deleteMessage,
  showGIFs,
  setshowGIFs,
  gifSearch,
  setGifSearch,
  sendMessage,
  gifs,
  setGif,
  foundGif,
  text,
  setText,
  getGifsSearch,
  setShowChat,
  setShowModChat,
  handleInputChange,
  maxLength,
}) => {
  const inputRef = useRef(null);

  const [mention, setMention] = useState(false);

  const [xFalse, setXFalse] = useState(false);

  const [str, setStr] = useState(" ");

  function checkWord(word) {
    word.split(" ").map((x) => {
      if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
        setMention(true);
      } else {
        setMention(false);
      }
    });
  }

  function addMention(e, message) {
    let messageArray = message.split(" ");
    messageArray.pop();
    messageArray.push(e.currentTarget.attributes.value.value);
    setMessage(messageArray.join(" ").toString());
    setMention(false);
  }

  useEffect(() => {
    checkWord(message);
  }, [message]);

  useEffect(() => {
    message.split(" ").map((x) => {
      if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
        setStr(x);
      }
    });
  }, [message]);

  return (
    <Fragment>
      <div className="live-stream-side-container border-left grey">
        {user.channelid === profile.channelid && isAuthenticated ? (
          <div className="container-name">
            <i
              className="far fa-window-close fa-2x red close-window"
              onClick={() => setShowChat(false)}
            ></i>
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowModChat(true);
                setShowChat(false);
              }}
            >
              <i className="fas fa-users-cog red mr-5"></i>Mods
            </p>
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowChat(true);
                setShowModChat(false);
              }}
            >
              <i className="far fa-comments red mr-5"></i>Chat
              <i className="far fa-check-circle red fa-sm mx-5"></i>
            </p>
            <i className="fas fa-external-link-alt fa-lg red pop-out"></i>
          </div>
        ) : (
          <div className="container-name">
            <i
              className="far fa-window-close fa-2x red close-window"
              onClick={() => setShowChat(false)}
            ></i>
            <p className="container-title cursor red">
              <i className="far fa-comments red mr-5"></i>Chat
            </p>
            {/* <i className="fas fa-external-link-alt fa-lg red pop-out"></i> */}
          </div>
        )}
        <ScrollToBottom className="all-content">
          {messages.map((message, index) => (
            <MentorChatMessageItem
              key={index}
              user={user}
              message={message}
              deleteMessage={deleteMessage}
            />
          ))}
        </ScrollToBottom>
        {user && user.role !== "employer" && (
          <div>
            <div className="comment-gif-input-hidden">
              {showGIFs &&
                foundGif === "" &&
                user.founding_supporter_type !== "Good" &&
                isAuthenticated && (
                  <div className="giphy-container">
                    <div className="wrap-container">
                      <div
                        className={`powered-by-giphy ${
                          user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        Powered By
                      </div>
                      <img
                        src={
                          "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Giphy_Logo.png"
                        }
                        style={{
                          width: "80px",
                          margin: "0px 10px",
                        }}
                        alt="logo"
                      />
                      <i
                        className={`far fa-times-circle fa-lg ${
                          user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        } gif-x`}
                        onClick={() => setshowGIFs(false)}
                      ></i>
                    </div>
                    <div
                      className="gifs"
                      id={`${
                        user.role === "innovator"
                          ? "green-scroll"
                          : user && user.role === "mentor"
                          ? "red-scroll"
                          : user && user.role === "employer"
                          ? "blue-scroll"
                          : ""
                      }`}
                    >
                      {!gifSearch &&
                        gifs.map((gif) => (
                          <div
                            className="gif-choice"
                            onClick={(e) => {
                              setGif(e.target.attributes["src"].value);
                              inputRef.current.focus();
                            }}
                          >
                            <GifItem key={gif.id} gif={gif} />
                          </div>
                        ))}
                      {gifSearch &&
                        gifs.map((gif) => (
                          <div
                            className="gif-choice"
                            onClick={(e) => {
                              setGif(e.target.attributes["src"].value);
                              inputRef.current.focus();
                            }}
                          >
                            <GifItem key={gif.id} gif={gif} />
                          </div>
                        ))}
                    </div>
                    <form
                      className="gif-input-hidden"
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (text !== "") {
                          getGifsSearch({ text });
                          setText("");
                          setGifSearch(true);
                        }
                      }}
                    >
                      <input
                        type="text"
                        className="gif-input"
                        name="text"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="Search for GIFs..."
                      />
                      <button
                        type="submit"
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (text !== "") {
                            getGifsSearch({ text });
                            setText("");
                            setGifSearch(true);
                            setshowGIFs(false);
                          }
                        }}
                        className={`gif-input-button ${
                          user.role === "innovator"
                            ? "background-green"
                            : user && user.role === "mentor"
                            ? "background-red"
                            : user && user.role === "employer"
                            ? "background-blue"
                            : ""
                        }`}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                )}
            </div>
            {isAuthenticated && !user.banned && !user.timed_out && (
              <div className="chat-message-container">
                {gifs && foundGif !== "" && (
                  <div className="selected-gif-container">
                    <div>
                      <img
                        className="selected-gif"
                        alt="gif-avatar"
                        src={gifs && foundGif}
                      />
                      <i
                        className="far fa-times selected-gif-x"
                        onClick={() => {
                          setGif("");
                          setshowGIFs(false);
                        }}
                      ></i>
                    </div>
                  </div>
                )}
                {/* {mention && (
                  <div className="room-users-container">
                    <div className="room-users">
                      <ul>
                        {viewerCount &&
                          viewerCount
                            .filter((y) => {
                              return y.channelid.match(str.substring(1));
                            })
                            .map((c) => {
                              if (c.channelid !== "") {
                                return (
                                  <li
                                    onClick={(e) => {
                                      addMention(e, message);
                                      inputRef.current.focus();
                                    }}
                                    className={`room-user-item ${
                                      c.role === "innovator"
                                        ? "green"
                                        : c && c.role === "mentor"
                                        ? "red"
                                        : c && c.role === "employer"
                                        ? "blue"
                                        : ""
                                    } bold`}
                                    value={`@${c.channelid}`}
                                  >
                                    @{c.channelid}
                                  </li>
                                );
                              }
                            })}
                      </ul>
                    </div>
                  </div>
                )} */}
                <div className="chat-input-hidden">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="chat-avi-user"
                    alt="avatar"
                  />
                  <input
                    className="chat-input"
                    type="text"
                    value={message}
                    ref={inputRef}
                    onChange={handleInputChange}
                    maxLength={100}
                    onKeyPress={(e) => {
                      if (message.length <= maxLength && e.key === "Enter") {
                        sendMessage(e);
                      }
                    }}
                    placeholder="Type message here..."
                  />
                  {isAuthenticated &&
                    user.founding_supporter_type !== "Good" &&
                    user.founding_supporter_type !== "" && (
                      <div
                        className={`gif-button-container ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                        onClick={() => setshowGIFs(true)}
                      >
                        <p className="gif-button">GIF</p>
                      </div>
                    )}
                  <p className="white character-counter-comment">
                    {message.length}/{maxLength} characters
                  </p>
                </div>
              </div>
            )}
            {isAuthenticated && user.banned && (
              <div className="chat-message-container grey">
                <div className="user-banned red">
                  <i className="fa-solid fa-ban mr-5 fa-lg red"></i>Banned
                </div>
              </div>
            )}
            {isAuthenticated && user.timed_out && (
              <div className="chat-message-container grey">
                <div className="user-banned red">
                  <i className="fa-solid fa-clock mr-5 fa-lg red"></i>
                  Timed Out
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};

StreamChatRed.propTypes = {
  auth: PropTypes.object.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gif: state.gif,
});

export default connect(mapStateToProps, { getGifsSearch })(StreamChatRed);
